import { memo, useRef } from 'react';
import { useSelector } from 'react-redux';
import { useClickAway } from 'react-use';
import { Modal, Button, Row, Col } from 'react-bootstrap';
import ModalHeader from '../partials/modalHeader';
import NoteDropdown from '../partials/noteDropdown';

const PrescriptionNote = ({ note, setNote, isNoteModal, setIsNoteModal }) => {
  const ref = useRef(null);
  useClickAway(ref, () => {
    setIsNoteModal(false);
  });

  const allItemElementNotes = useSelector(
    (state) => state?.prescriptionReducer?.prescriptionInfo?.itemElementNotes || [],
  );
  const suggestions = allItemElementNotes.filter((n) => n.elementType === 'note');

  return (
    <Modal
      show={isNoteModal}
      size="md"
      onClick={(e) => e.stopPropagation()}
    >
      <ModalHeader title={'Notes'} action={setIsNoteModal} />
      <Modal.Body className="pb-3" ref={ref}>
        <Row className="mb-3">
          <Col>
            <NoteDropdown
              value={note}
              onChange={setNote}
              placeholder="Search/Add Note"
              suggestions={suggestions}
            />
          </Col>
        </Row>
        <Row>
          <Col className="text-center">
            <Button
              variant="primary"
              size="sm"
              onClick={() => setIsNoteModal(false)}
            >
              Ok
            </Button>
          </Col>
        </Row>
      </Modal.Body>
    </Modal>
  );
};

export default memo(PrescriptionNote);
